import React, { useEffect } from 'react';
import {
    Document, StyleSheet, Page, View, Text, Image, Font
} from '@react-pdf/renderer';

//import { Grid, Typography, Box, TableRow, TableBody, TableHead, Table, TableContainer } from '@mui/material'
//import { makeStyles } from '@mui/styles';
import { useThemeState } from '../../hookState/ThemeState';
import Logo from '../../assets/images/logo.png';
import DefaultEvent from '../../assets/images/default_event.jpg';
// import { styled } from '@mui/material/styles';
// import TableCell, { tableCellClasses } from '@mui/material/TableCell';

import moment from 'moment';
import CultureInfo from '../../utility/cultureInfo'
import Helper from '../../utility/helper';

// const useStyles = makeStyles({
//     gameDate: {
//         display: 'flex',
//         justifyContent: 'center',
//         position: 'relative',

//     },
//     logo: {
//         height: 57,
//     },
//     borderLight: {
//         borderBottom: '1px solid'
//     },
//     noBorder: {
//         borderBottom: 'none',
//     }
// });
// const StyledTableCell = styled(TableCell)(() => ({

//     [`&.${tableCellClasses.body}`]: {
//         fontSize: 12,
//         fontWeight: 700,
//         padding: '4px'
//     },
// }));

// const StyledTableRow = styled(TableRow)(() => ({


// }));

Font.register({
    family: 'Action NBA',
    fonts: [
        {
            src: `/fonts/ActionNBA-Bold-Web.woff`,
            fontWeight: 'bold'
        },
        
        {
            src: `/fonts/Action NBA App-Medium.ttf`,
            fontWeight: '900',
            fontStyle:'normal'
        },
    ]
});

Font.register({
    family: 'Roboto',
    fonts: [
        {
            src: `/fonts/Roboto-MediumItalic.ttf`,
            fontStyle:'italic'
        },
        {
            src: `/fonts/Roboto-Bold.ttf`,
            fontStyle:'normal'
        },
    ]
})

const PDFContainer = (props) => {

    //const classes = useStyles();
    const userInfo = Helper.getStorage('userInfo');
    const { data } = props;
    const [dates, setDates] = React.useState([]);
    const themeState = useThemeState();

    useEffect(() => {
        getDistinctDates(props.data);
    }, [props.data]);
    function getDates(startDate, endDate) {
        const dates = []
        let currentDate = startDate
        const addDays = function (days) {
            const date = new Date(this.valueOf())
            date.setDate(date.getDate() + days)
            return date
        }
        while (currentDate <= endDate) {
            dates.push(moment(currentDate).format('MM/DD/YYYY'))
            currentDate = addDays.call(currentDate, 1)
        }
        return dates
    }
    const getDistinctDates = (data) => {
        let activityDates = []
        data && data.activities.map((item) => {
            let startDate = item.actualData.startDateTime !== null ? moment(item.actualData.startDateTime).format('MM/DD/YYYY') : null;
            let endDate = null//item.actualData.endDateTime !== null ? moment(item.actualData.endDateTime).format('MM/DD/YYYY') : null;
            let range = [];
            if (startDate !== null && endDate !== null) {
                range = getDates(moment(startDate), moment(endDate))
            } else if (startDate !== null && endDate === null) {
                range = [startDate];
            } else if (startDate === null && endDate !== null) {
                range = [endDate];
            }
            //let range = getDates(moment(startDate), moment(endDate))

            activityDates = [...activityDates, ...range]
        })
        let uniqueDates = [... new Set(activityDates)]


        uniqueDates = uniqueDates.sort((a, b) => moment(a) - moment(b));

        setDates(uniqueDates);
    }

    return (
        <Document style={styles.root}>
            <Page size="A4" orientation="landscape" style={styles.page}>

                {
                    data &&
                    <>
                        <View style={{ justifyContent: 'flex-end', alignItems: 'flex-end', alignSelf: 'flex-end' }}>
                            <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8 ,color:'#808080'}}>{moment().format(CultureInfo.GetCultureInfo().DateTimeFormat)}</Text>
                        </View>
                        <View style={styles.section}>
                            <View style={{ flex: 0.3 }}>
                                <Image
                                    style={styles.img}
                                    src={{
                                        uri:
                                            !themeState.eventEnabled.value
                                                ? Logo
                                                : themeState.eventImageUrl.value != ''
                                                    ? themeState.eventImageUrl.value
                                                    : DefaultEvent
                                    }}
                                />
                            </View>
                            <View style={{ flex: 0.3, justifyContent: 'center', alignItems: 'center' }}>
                                <Text style={{ textDecoration: 'underline', fontFamily: 'Action NBA', fontSize: 26, fontWeight: '700', color: "#1d428a" }}>{props.data.participantName}</Text>
                                <Text style={{ fontFamily: 'Roboto',fontStyle: 'italic',  fontSize: 12, textAlign: 'center', marginTop: 10 }}>{`${props.data?.eventName} Individual Schedule`}</Text>
                            </View>
                            <View style={{ flex: 0.3 }}></View>
                        </View>
                        <View style={styles.titleRow}>
                            {/* <View style={{ alignItems: 'flex-start', flex: 0.11 }}>
                                <Text style={{fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, verticalAlign: 'bottom' ,paddingBottom: 2}}>Date</Text>
                            </View> */}
                            <View style={{ alignItems: 'center', flex: 0.07 }}>
                                <Text style={{fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, verticalAlign: 'bottom',paddingBottom: 2 }}>Start</Text>
                            </View>
                            <View style={{ alignItems: 'center', flex: 0.07 }}>
                                <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8,verticalAlign: 'bottom' ,paddingBottom: 2}}>End</Text>
                            </View>
                            <View style={{ alignItems: 'center', flex: 0.20 }}>
                                <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8,verticalAlign: 'bottom',paddingBottom: 2 ,marginLeft:8}}>Event</Text>
                            </View>
                           { (userInfo.roles && Helper.isEventStaff(userInfo)) &&  <View style={{ alignItems: 'flex-start', flex: 0.25 }}>
                                <Text style={{ fontFamily: 'Roboto', fontStyle: 'normal', fontSize: 8, verticalAlign: 'bottom', paddingBottom: 2, marginLeft: 8 }}>Participants</Text>
                            </View>}
                            <View style={{ alignItems: 'center', flex: 0.15 }}>
                                <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, verticalAlign: 'bottom' ,paddingBottom: 2}}>Location</Text>
                            </View>
                            <View style={{ alignItems: 'flex-start', flex: 0.40 }}>
                                <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, verticalAlign: 'bottom',paddingBottom: 2 , marginLeft:4}}>Details</Text>
                            </View>
                        </View>

                        {dates.length > 0 && dates.map((date, i) => {
                            let activities = props.data.activities.filter(x => moment(x.actualData.startDateTime).format(CultureInfo.GetCultureInfo().DateFormat) === moment(date).format(CultureInfo.GetCultureInfo().DateFormat))

                            return activities && activities.map((item) => {
                                let actPart = [];
                                item.actualData.participants && item.actualData.participants.length > 0 && item.actualData.participants.map((vals) => {
                                    actPart.push(vals.participant.replace(',', ' '))
                                })
                                return (
                                <>
                                <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', borderBottom:'1px solid black', backgroundColor: '#dae2f1' }}>
                                    <Text style={{ fontFamily: 'Roboto', fontStyle: 'normal', fontSize: 8, fontWeight: 900 }}>{moment(date).format('ddd, MMMM D, YYYY')}</Text>
                                </View>
                                <View key={i} style={{display:'flex',flexDirection:'row',justifyContent:'space-between', borderBottom:'1px solid black'}}>
                                    {/* {index === 0 ?
                                        <View style={{ padding : 2 , alignItems: 'flex-start', alignSelf:'center', flex: 0.11, borderBottom: activities.length == 1  && (item.actualData.subActivities && item.actualData.subActivities.length === 0) ? '1px solid black' : 'none', fontWeight: 700 }}>
                                            <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 900 }}>{moment(date).format('ddd, MMMM D, YYYY')}</Text>
                                        </View>
                                        :
                                        <View style={{ padding : 2 ,alignItems: 'flex-start', alignSelf:'center', flex: 0.11, borderBottom: index + 1 === activities.length  && (item.actualData.subActivities && item.actualData.subActivities.length === 0) ? '1px solid black' : 'none', fontWeight: 700 }}>
                                            <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 900 }}> </Text>
                                        </View>
                                    } */}
                                    <View style={{ padding : 2 ,alignItems: 'center', flex: 0.07  }}>
                                        <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 900 }}>{moment(item.actualData.startDateTime).format( 'hh:mm:ss') === '12:00:00' ? '' : moment(item.actualData.startDateTime).format(CultureInfo.GetCultureInfo().TimeFormat)}</Text>
                                    </View>
                                    <View style={{ padding : 2 ,alignItems: 'center', flex: 0.07  }}>
                                        <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 800 }}>{item.actualData.endDateTime !== null ? moment(item.actualData.endDateTime).format( 'hh:mm:ss') === '12:00:00' ? '' :  moment(item.actualData.endDateTime).format(CultureInfo.GetCultureInfo().TimeFormat) : ''}</Text>
                                    </View>
                                    <View style={{ padding : 2 ,alignItems: 'center', flex: 0.20, wordBreak: 'break-word' }}>
                                        <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 800 }}>{item.actualData.activityName}</Text>
                                    </View>
                                    {(userInfo.roles && Helper.isEventStaff(userInfo)) && <View style={{ padding: 2, alignItems: 'flex-start', flex: 0.25, wordBreak: 'break-word' }}>
                                        <Text style={{ fontFamily: 'Roboto', fontStyle: 'normal', fontSize: 8, fontWeight: 800 }}>{actPart.toString()}</Text>
                                    </View>}
                                    <View style={{ padding : 2 ,alignItems: 'center', flex: 0.15 , wordBreak: 'break-word' }}>
                                        <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 800 }}>{item.actualData.location}</Text>
                                    </View>
                                    <View style={{ padding : 2 ,alignItems: 'flex-start', flex: 0.40 , wordBreak: 'break-word' }}>
                                        <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 800 ,}}>{item.actualData.notes}</Text>
                                    </View>
                                </View>
                                {item.actualData.subActivities && item.actualData.subActivities.length > 0 && item.actualData.subActivities.map((subAct, j) => {
                                        let subActPart = [];
                                        subAct.subActivityParticipants && subAct.subActivityParticipants.length > 0 && subAct.subActivityParticipants.map((vals) => {
                                            subActPart.push(vals.participant.replace(',', ' '))
                                        })
                                        return <View key={j} style={{display:'flex',flexDirection:'row',justifyContent:'space-between', backgroundColor:'#ebeaed', borderBottom: '1px solid black'}}>
                                        {/* {index === 0 ?
                                            <View style={{ padding : 2 , alignItems: 'flex-start', alignSelf:'center', flex: 0.11, fontWeight: 700 }}>
                                                <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 900 }}></Text>
                                            </View>
                                            :
                                            <View style={{ padding : 2 ,alignItems: 'flex-start', alignSelf:'center', flex: 0.11, fontWeight: 700 }}>
                                                <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 900 }}> </Text>
                                            </View>
                                        } */}
                                        <View style={{ padding : 2 ,alignItems: 'center', flex: 0.07 ,  }}>
                                            <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 900 }}>{subAct.startDateTime !== null ? moment(subAct.startDateTime).format(CultureInfo.GetCultureInfo().TimeFormat) : ''}</Text>
                                        </View>
                                        <View style={{ padding : 2 ,alignItems: 'center', flex: 0.07 ,  }}>
                                            <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 800 }}>{subAct.endDateTime !== null ? moment(subAct.endDateTime).format(CultureInfo.GetCultureInfo().TimeFormat) : ''}</Text>
                                        </View>
                                        <View style={{ padding : 2 ,alignItems: 'center', flex: 0.20, wordBreak: 'break-word',  }}>
                                            <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 800 }}>{subAct.subActivityName}</Text>
                                        </View>
                                        {(userInfo.roles && Helper.isEventStaff(userInfo)) && <View style={{ padding: 2, alignItems: 'flex-start', flex: 0.25, wordBreak: 'break-word',  }}>
                                            <Text style={{ fontFamily: 'Roboto', fontStyle: 'normal', fontSize: 8, fontWeight: 800 }}>{subActPart.toString()}</Text>
                                        </View>}
                                        <View style={{ padding : 2 ,alignItems: 'center', flex: 0.15 , wordBreak: 'break-word',  }}>
                                            <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 800 }}>{subAct.location}</Text>
                                        </View>
                                        <View style={{ padding : 2 ,alignItems: 'flex-start', flex: 0.40 , wordBreak: 'break-word',  }}>
                                            <Text style={{ fontFamily: 'Roboto',fontStyle: 'normal',fontSize: 8, fontWeight: 800 ,}}>{subAct.notes}</Text>
                                        </View>
                                    </View>
                                    })}
                                </>)
                            })
                        })}


                        {/* <Grid container sx={{ display: 'flex', flexDirection: 'row-reverse' }}> <Typography variant='caption'>  {moment().format(CultureInfo.GetCultureInfo().DateTimeFormat)}</Typography></Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={3} md={3} justifyContent="flex-start" display="flex">
                                <Box
                                    component="img"
                                    className={classes.logo}
                                    alt="logo."
                                    src={
                                        !themeState.eventEnabled.value
                                            ? Logo
                                            : themeState.eventImageUrl.value != ''
                                                ? themeState.eventImageUrl.value
                                                : DefaultEvent
                                    }
                                />
                            </Grid>

                            <Grid flexDirection="column" justifyContent='center' item xs={6} md={6}>

                                <Typography align="center" variant="h6" className={'fontBold'} color="#1d428a" sx={{ textDecoration: 'solid 4px underline', fontFamily: 'Action NBA', fontSize: '2.6rem', fontWeight: 600, }}>{props.data.participantName}</Typography>

                                <Typography align="center" variant="h6" sx={{ fontStyle: 'italic', fontSize: '1.2rem' }}>{`${props.data?.eventName} Individual schedule`}</Typography>
                            </Grid>
                            <Grid item xs={3} md={3} justifyContent="center" alignItems="center" display="flex"></Grid>

                        </Grid>
                        <Grid container direction="row" alignItems="flex-start" justify="center" marginTop={'16px'} >
                            <TableContainer>
                                <Table size="small" aria-label="a dense table" sx={{ width: '100%' }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell align='left' sx={{ borderBottom: '1px solid black', fontSize: 12, fontWeight: 800, width: '12%', padding: '0 4px', verticalAlign: 'bottom' }}>Date</StyledTableCell>
                                            <StyledTableCell align="center" sx={{ borderBottom: '1px solid black', fontSize: 12, fontWeight: 800, width: '7%', padding: '0 4px', verticalAlign: 'bottom' }}>Start</StyledTableCell>
                                            <StyledTableCell align="center" sx={{ borderBottom: '1px solid black', fontSize: 12, fontWeight: 800, width: '7%', padding: '0 4px', verticalAlign: 'bottom' }}>End</StyledTableCell>
                                            <StyledTableCell align="left" sx={{ borderBottom: '1px solid black', fontSize: 12, fontWeight: 800, width: '25%', padding: '0 4px', verticalAlign: 'bottom' }}>Event</StyledTableCell>
                                            <StyledTableCell align="center" sx={{ borderBottom: '1px solid black', fontSize: 12, fontWeight: 800, width: '25%', padding: '0 4px', verticalAlign: 'bottom' }}>Location</StyledTableCell>
                                            <StyledTableCell align="left" sx={{ borderBottom: '1px solid black', fontSize: 12, fontWeight: 800, width: '25%', padding: '0 4px', verticalAlign: 'bottom' }}>Details</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {dates.length > 0 && dates.map((date, i) => {
                                            let activities = props.data.activities.filter(x => moment(x.actualData.startDateTime).format(CultureInfo.GetCultureInfo().DateFormat) === moment(date).format(CultureInfo.GetCultureInfo().DateFormat))

                                            return activities && activities.map((item, index) => {

                                                return <StyledTableRow key={i} >
                                                    {index === 0 && <StyledTableCell sx={{ backgroundColor: i % 2 === 0 ? "#FFFFFF" : "#DAE2F1", borderBottom: '1px solid black', fontWeight: 700 }} align='left' rowSpan={activities.length} >
                                                        <Typography fontSize={12} variant="h4" fontWeight={800} > {moment(date).format('ddd, MMMM D, YYYY')}</Typography>
                                                    </StyledTableCell>
                                                    }
                                                    <StyledTableCell align='center' sx={{ backgroundColor: i % 2 === 0 ? "#FFFFFF" : "#DAE2F1", borderBottom: index + 1 === activities.length ? '1px solid black' : 'none' }}>
                                                        <Typography fontSize={12} variant="h4" fontWeight={800}  >  {moment(item.actualData.startDateTime).format(CultureInfo.GetCultureInfo().TimeFormat)} </Typography>
                                                    </StyledTableCell>
                                                    <StyledTableCell align='center' sx={{ backgroundColor: i % 2 === 0 ? "#FFFFFF" : "#DAE2F1", borderBottom: index + 1 === activities.length ? '1px solid black' : 'none' }}>
                                                        <Typography fontSize={12} variant="h4" fontWeight={800} >  {item.actualData.endDateTime !== null ? moment(item.actualData.endDateTime).format(CultureInfo.GetCultureInfo().TimeFormat) : ''}</Typography>
                                                    </StyledTableCell>
                                                    <StyledTableCell align='left' sx={{ wordBreak: 'break-word', backgroundColor: i % 2 === 0 ? "#FFFFFF" : "#DAE2F1", borderBottom: index + 1 === activities.length ? '1px solid black' : 'none' }}>
                                                        <Typography fontSize={12} variant="h4" fontWeight={800} > {item.actualData.activityName}</Typography>
                                                    </StyledTableCell>
                                                    <StyledTableCell align='center' sx={{ wordBreak: 'break-word', backgroundColor: i % 2 === 0 ? "#FFFFFF" : "#DAE2F1", borderBottom: index + 1 === activities.length ? '1px solid black' : 'none' }}>
                                                        <Typography fontSize={12} variant="h4" fontWeight={800}>  {item.actualData.location}</Typography>
                                                    </StyledTableCell>
                                                    <StyledTableCell align='left' sx={{ wordBreak: 'break-word', backgroundColor: i % 2 === 0 ? "#FFFFFF" : "#DAE2F1", borderBottom: index + 1 === activities.length ? '1px solid black' : 'none', }}>
                                                        <Typography fontSize={12} variant="h4" fontWeight={800} sx={{, }}> {item.actualData.notes}</Typography>
                                                    </StyledTableCell> */}
                                                    {/* <Grid item lg={1} md={1} sm={1} xs={1}>
                                                        <Typography align="center" variant="h4" fontSize={12} fontWeight={500}>{moment(item.actualData.endDateTime).format('hh:mm A')}</Typography>
                                                    </Grid> */}

                                                    {/* <Grid item lg={3} md={3} sm={3} xs={3}>
                                                        <Typography align="left" variant="h4" fontSize={12} fontWeight={500} marginLeft={2} color={'#FF0000'}>{item.actualData.notes}</Typography>
                                                    </Grid> */}
                                                {/* </StyledTableRow>
                                            })
                                        })}

                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Grid> */}



                    </>
                }

            </Page>
        </Document>
    )
}
const styles = StyleSheet.create({
    root: {
        backgroundColor: '#fff',
    },
    page: {
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop:5,
        paddingBottom:5
    },
    section: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    gameInfoHeader: {
        marginLeft: 4,
        color: '#ba461b',
        fontSize: '12px',
        paddingTop: 16,
        fontFamily: 'Helvetica-Bold'
    },
    line: {
        display: 'inline-block',
        width: '100%',
        marginTop: 4,
        borderTop: `2px solid #A9A9A9`
    },
    img: {
        height: 50,
        width: 70
    },
    titleRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: '1 px solid black',
        marginTop: '16px'
    },
    titlesubActRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: '1 px solid black', 
        backgroundColor: '#DAE2F1'
    }

});


export default PDFContainer;